import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    en: require('./en.i18n').default, // eslint-disable-line
  },
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});

// Add extra function $tu, which means translation/undefined
// When translation is not found, return undefined
i18n.tu = (path, ...args) => {
  if (i18n.te(path) === false) {
    return undefined;
  }
  return i18n.t(path, ...args);
};
Vue.prototype.$tu = i18n.tu;

export default i18n;
